import React, {useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SvgIcon from "@mui/material/SvgIcon";
import FormHelperText from "@mui/material/FormHelperText";

import {ROUTES} from "../../../../../routes";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import {
  restorePaymentInfo,
  setShippingErrors,
  setShippingInfo
} from "../../../../../actions/paymentFunctions";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartBackButton from "../groheCartBackButton";
import Misc from "../../../../../misc/misc";
import {postVerifyAddress} from "../../../../../api/look-api";
import {COLORS} from "../../../../../colorThemes";
import {GroheNoteAddIcon} from "../../../../common/icons";
import GroheBillingAndShippingInputs from "./groheBillingAndShippingInputs";
import Analytics from "../../../../../analytics";
import {getAnalyticsEcommerceValues} from "../../../../../analyticsEcommerceParams";


const GroheCartShipping = (props) => {

  const {isMobile, history, shippingAddress, setShippingInfo, restorePaymentInfo, setShippingErrors, shippingErrors} = props;
  const [defaultValues] = useState(shippingAddress);
  const [isLoading, setIsLoading] = useState(false);
  const [addressError, setAddressError] = useState("");

  const disabled = !shippingAddress.address1 || !shippingAddress.postal || Misc.hasErrors(shippingErrors);

  const backButtonClick = () => {
    restorePaymentInfo({
      shippingAddress: defaultValues
    });
    history.push(ROUTES.cartBilling);
  };

  const confirmButtonClick = async () => {

    const {currency, value, items} = getAnalyticsEcommerceValues();
    Analytics.sendEcommerceEvent("add_shipping_info", {currency, value, items,
      coupon: "", // "SUMMER_FUN" // we are not using that
      shipping_tier: "", // not sure about it
    });

    setIsLoading(true);
    const addressValidated = await postVerifyAddress(shippingAddress);
    setIsLoading(false);
    if (addressValidated && addressValidated.isConfirmed
      && (addressValidated.isConfirmed === "Y" || addressValidated.isConfirmed === "D")) {
      history.push(ROUTES.cartBilling);
      return true
    }
    setAddressError(addressValidated.errorDescription || " ");
    return false
  };

  const stickyFooterButtons = [
    {
      translate: "buttons.back",
      classes: "look-button--secondary",
      onClick: () => {
        history.push(ROUTES.cartBilling);
      }
    },
    {
      translate: "grohe.cart.shipping.submitButton",
      classes: "look-button--blue gc-sticky__button--60",
      onClick: confirmButtonClick,
      disabled
    },
  ];

  return (
    <div className="gc">
      <div className="gc-body">
        <GroheCartHeaderCommon title="grohe.cart.shipping.title" subTitle="grohe.cart.shipping.subTitle"/>
        <GroheBillingAndShippingInputs addressObject={shippingAddress}
                                       setAddressInfo={setShippingInfo}
                                       addressErrors={shippingErrors}
                                       setAddressErrors={setShippingErrors}/>
        {addressError ? (
          <FormHelperText className="gc-content MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained">
            <FormattedMessage id="look.inputs.errors.incorrectAddress"/>
            {" " + addressError}
          </FormHelperText>
        ) : null}
        {isMobile ? null : (
          <div className="gc-content">
            <div className="gc-form__submit">
              <div className="gc-form__submit-left"/>
              {isMobile ? null : (
                <div className="gc-form__submit-right">
                  <GroheCartBackButton backButtonClick={backButtonClick}/>
                  <Button className={"look-button look-button--blue look-button--big look-button--large nowrap"
                    + (isLoading ? " grohe-look__button--loading" : "")}
                          disabled={disabled}
                          startIcon={isLoading
                            ? <CircularProgress className="grohe-look__button-loader-small" style={{'color': COLORS.white}}/>
                            : (
                              <SvgIcon>
                                <GroheNoteAddIcon color={COLORS.white}/>
                              </SvgIcon>
                            )}
                          onClick={confirmButtonClick}>
                    <FormattedMessage id="grohe.cart.shipping.submitButton"/>
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
        {isMobile ? <div className="gc-spacer"/> : null}
      </div>
      {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {shippingAddress, shippingErrors} = store.paymentState;

  return {
    isMobile,
    shippingAddress,
    shippingErrors,
  };
};

const mapDispatchToProps = {
  setShippingInfo,
  restorePaymentInfo,
  setShippingErrors,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroheCartShipping))
